module.exports = "<div class = \"title\">\r\n  <h3 class=\"title\">{{title}}</h3>\r\n</div>\r\n<div>\r\n  <iframe [src]=\"src\" height=\"100%\" width=\"100%\" allowfullscreen=\"true\" allowtransparency=\"true\" frameborder=\"no\" border=\"0\"></iframe>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/video/list/show.component.html
// module id = ./src/app/video/list/show.component.html
// module chunks = main